import React from 'react';
import { PAGE_CHANGE_REQUEST } from '../models/Engine';

const usePageChangeListner = (): string | null => {
  const [activePage, setActivePage] = React.useState<string | null>(null);

  React.useEffect(() => {
    document.addEventListener('CHANGE_PAGE', detectPageChange);
    return () => {
      document.removeEventListener('CHANGE_PAGE', detectPageChange);
    };
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const detectPageChange = (e: any) => {
    const request = e.detail as PAGE_CHANGE_REQUEST;
    if (request.message) {
      window.MESSAGE = request.message;
    } else {
      window.MESSAGE = '';
    }
    setActivePage(request.page);
  };

  return activePage;
};

export default usePageChangeListner;
